import {
    accessibleBtn,
    pageBody
} from "./_selectors";

const switchStyle = () => {
    pageBody.classList.toggle("accessible");
}

accessibleBtn.addEventListener('click', switchStyle);
